import {VersionVariants} from '@jobseeker/lotus/enums';
import {Box, InputAdornment, styled} from '@mui/material';
import {getKeywordSearch} from '@jobseeker/feature-search/helpers';
import {useState} from 'react';
import TextField from '@jobseeker/lotus/elements/Input';
import {Image} from '@jobseeker/lotus/components/Image';
import {SearchIconGrey} from '@jobseeker/lotus/icons';

const Listbox = styled('div')<any>(({theme, variant}: any) => ({
  width: '230px',
  zIndex: 10,
  position: 'sticky',
  listStyle: 'none',
  boxShadow: '0 13px 14px 0 rgba(0,0,0,.13)',
  // padding: '8px 0',
  backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#000',
  overflow: 'auto',
  maxHeight: 650,
  // border: '1px solid',
  marginLeft: -8,
  // borderColor:
  //   variant === VersionVariants.VERSION_ONE ? '#bbb' : theme.palette.divider,
  borderRadius: variant === VersionVariants.VERSION_ONE ? 6 : 16,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  marginTop: 4,
  '& li.Mui-focused': {
    backgroundColor: '#4a8df6',
    color: 'white',
    cursor: 'pointer',
  },
  '& li:active': {
    backgroundColor: '#2977f5',
    color: 'white',
  },
  [theme.breakpoints.down('sm')]: {
    width: '220px', // Example: Change width for small screens
    marginTop: 0, // Example: Adjust zIndex on mobile
    marginLeft: '16px',
  },
}));

const List = styled('li')(() => ({
  padding: '12px 16px',
  fontSize: '16px',
  ':hover': {
    backgroundColor: '#F2F5FA',
  },
}));
export default function Search({setKeyword, keyword}: any) {
  const onSearchFormChange = (value: any) => {
    setKeyword(value);
    console.log({llop: value});
    if (value?.length > 1) {
      getKeywordSearch(value).then(searchInfo => {
        setKeywordSearch(searchInfo);
      });
      setAutocomplete(true);
    }
  };

  const [keywordSearch, setKeywordSearch] = useState<string[]>([]);

  const [autocomplete, setAutocomplete] = useState<any>(false);
  const onFilterChanges = (e: any, value?: any) => {
    onSearchFormChange(e?.target?.value);
    // onFilter && onFilter(searchFormValue)
  };
  const {showAutocomplete, onAutoCompleteSelect, autocompleteList} = {
    showAutocomplete: autocomplete,
    onAutoCompleteSelect: () => setAutocomplete(false),
    autocompleteList: keywordSearch,
  };
  const onAutoCompleteListClick = (value: string) => {
    if (value?.length > 0) {
      if (onAutoCompleteSelect) {
        onAutoCompleteSelect();
        onFilterChanges({target: {name: 'query', value}}, value);
        setAutocomplete(false);

        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        // Update the keyword param with new value (replacing spaces with hyphens)
        params.set('keyword', value.replace(/\s+/g, '-'));

        // Reconstruct URL with the same pathname and updated query string
        const newUrl = `${url.pathname}?${params.toString()}`;
        window.location.href = newUrl;
      }
    }
  };
  const [menuOpen, setOpen] = useState<any>(false);

  const setMenuOpen = (value: any) => {
    // console.log(v, menuOpen);
    if (value && value === menuOpen) {
      setMenuOpen(false);
    } else setOpen(value);
  };
  const textClick = (e: any) => {
    setMenuOpen(false);
    // textBarRef.current.focus();
  };
  return (
    <>
      <Box>
        <TextField
          size="small"
          onClick={textClick}
          placeholder="Search Jobs"
          variant={VersionVariants.VERSION_TWO}
          aria-autocomplete="list"
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault(); // (Optional) Prevent form submission if any

              onAutoCompleteListClick(keyword);
            }
          }}
          aria-expanded="true"
          autoComplete="off"
          spellCheck="false"
          aria-invalid="false"
          name="query"
          onChange={onFilterChanges}
          hirist={true}
          sx={{
            zIndex: 3,
            fontSize: 17,
            borderRadius: '22px',
            width: '220px',
            color: 'rgba(0,0,0,.4)',
            height: '42px',
            mt: -0.5,
            ml: {xxs: 2, md: 0},

            '.MuiInputBase-root': {
              borderRadius: '22px',
              pl: {xxs: 1.5, md: 2},
              color: 'rgba(0,0,0,.4)',

              height: '55px !important',
              fontSize: 16,
            },

            '& .MuiOutlinedInput-root': {
              borderRadius: '22px',
              height: '55px !important',
              fontSize: 17,
              border: '1px #7E7E7E33 !important', // Remove any border
              boxShadow: 'none !important', // Prevents shadow effect
              '&:hover': {
                border: '1px #7E7E7E33 !important', // Remove any border
                boxShadow: 'none !important',
              },
              '&.Mui-focused': {
                border: '1px #7E7E7E33 !important', // Remove any border
                boxShadow: 'none !important',
              },
            },

            '& .MuiInputBase-root': {
              borderRadius: '22px',
              pl: {xxs: 1.5, md: 2},
              height: '55px !important',
              fontSize: 17,
            },

            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid #7E7E7E33 !important', // Always visible border
              display: {xxs: 'inline', md: 'none !important'},
            },
          }}
          value={keyword}
          InputProps={{
            style: {
              height: '39px',
              backgroundColor: 'white',
              cursor: 'default',
            },
            startAdornment: (
              <InputAdornment position="start">
                <Image
                  src={SearchIconGrey}
                  alt={'Search'}
                  width={18}
                  height={18}
                />
              </InputAdornment>
            ),
          }}
        />
        {showAutocomplete &&
          autocompleteList &&
          autocompleteList?.length > 0 && (
            <Listbox
              variant={VersionVariants.VERSION_TWO}
              sx={{
                position: 'absolute',
              }}
            >
              {autocompleteList?.map((keyword: any, index: any) => (
                <List
                  style={{cursor: 'default'}}
                  key={`searchform-keyword-${index}`}
                  onClick={e => onAutoCompleteListClick(keyword)}
                >
                  {keyword}
                </List>
              ))}
            </Listbox>
          )}
      </Box>
    </>
  );
}
